import React from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import {
  DemandContent
} from './sub-view/need-offer';
import {LoadingPage} from 'components/loading-page';
import {Textarea} from 'components/vitrade-forms/common';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';

class MybusinessNeedOffer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tabIndex: 0
    };
    this.onSelectTab = this.onSelectTab.bind(this);
  }

  onSelectTab(tabIndex) {
    this.setState({tabIndex});
  }

  render() {
    return (
      <section className="need-offer-container need-offer-list-business-container mb35">
        <h2 className="need-offer-title">Quản lý nhu cầu</h2>
        <Tabs className="need-offer-tab" selectedIndex={this.state.tabIndex} onSelect={tabIndex => this.onSelectTab(tabIndex)}>
          <TabList className="center">
            <div className="need-offer-tab-wrap">
              <Tab className="need-offer-tab-item">Nhu cầu đã đăng</Tab>
              <Tab className="need-offer-tab-item">Nhu cầu của tôi</Tab>
            </div>
          </TabList>
          <TabPanel className="need-offer-tab-panel">
            {this.props.myBusinesses && <DemandContent businessId={this.props.myBusinesses.id} />}
          </TabPanel>
          <TabPanel className="need-offer-tab-panel">
            {this.props.user && <DemandContent userId={this.props.user.id} />}
          </TabPanel>
        </Tabs>
      </section>
    );
  }
}

const mapStateToProp = (state) => {
  return {
    user: state.auth.user,
    myBusinesses: state.myBusinesses.mainBusiness
  };
};

export default connect(mapStateToProp)(MybusinessNeedOffer);



// WEBPACK FOOTER //
// ./components/my-business/MybusinessNeedOffer.jsx